import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ICartState {
  sessionId: string | null;
  visitors: any[];
  cartItems: any[];
  hotelCart: any[];
  ticketDate: string | null;
  currentStep: number;
  loading: boolean;
  error: string | null;
}

const initialState: ICartState = {
  sessionId: null,
  visitors: [],
  cartItems: [],
  hotelCart: [],
  ticketDate: null,
  currentStep: 0, // 0: Cart Details, 1: Payment
  loading: false,
  error: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
    setVisitors: (state, action: PayloadAction<any[]>) => {
      state.visitors = action.payload;
    },
    setCartItems: (state, action: PayloadAction<any[]>) => {
      state.cartItems = action.payload;
    },
    setHotelCart: (state, action: PayloadAction<any[]>) => {
      state.hotelCart = action.payload;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTicketDate: (state, action: PayloadAction<string | null>) => {
      state.ticketDate = action.payload;
    },
  },
});

export const {
  setSessionId,
  setVisitors,
  setCartItems,
  setHotelCart,
  setStep,
  setLoading,
  setError,
  setTicketDate,
} = cartSlice.actions;

export const cartReducer = cartSlice.reducer;
export default cartSlice.reducer;
